/**
 * Get the my booked events
 * @param {object} state - The vuex state object
 * @return {object[]} get array of booked events
 */
export const getAllEvents = (state) => {
  return state.myEvents
};
